export default __webpack_public_path__ + "static/media/deptIcon.95c45058.svg";